import {
  HydratedChatbot,
  useDeleteChatbot as useDeleteChatbotMutation,
  useFavoriteAssets,
} from "@zapier/client";
import { useTranslations } from "@zapier/i18n";
import { AssetTypes, useNotification } from "@zapier/utils";

export function useDeleteChatbot(
  chatbot: HydratedChatbot | undefined,
  folderId?: string, // used for cache invalidation in mutations
) {
  const { mutate, isPending } = useDeleteChatbotMutation({ folderId });
  const { createNotification } = useNotification();
  const t = useTranslations("chatbot-delete-modal");

  const { removeFromFavorites } = useFavoriteAssets();

  const deleteChatbot = () => {
    if (!chatbot) {
      return;
    }

    mutate(
      { id: chatbot.id ?? "" },
      {
        onSuccess: () => {
          createNotification({
            message: t("notifications.delete-success", {
              name: chatbot.name ?? "",
            }),
            type: "success",
          });

          if (chatbot.id) {
            removeFromFavorites(chatbot.id, AssetTypes.Chatbot);
          }
        },
        onError: () => {
          createNotification({
            message: t("notifications.delete-error", {
              name: chatbot.name ?? "",
            }),
            type: "error",
          });
        },
      },
    );
  };

  return { deleteChatbot, isPending };
}
